var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-label',{staticClass:"pb-2"},[_vm._v(_vm._s(_vm.label))]),_c('v-data-table',{staticClass:"elevation-1 mt-2",attrs:{"headers":_vm.headers,"items":_vm.rows,"items-per-page":5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }